<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="登录数" name="login">
        <el-card>
          <el-date-picker v-model="dateVal1" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" class="date-search"/>
          <el-button type="primary" icon="el-icon-search" @click="queryLoginData()" circle size="mini"/>
          <el-table v-if="tableAble" :data="userLoginCount">
            <el-table-column label="数量" prop="userCount"/>
            <el-table-column label="时间" prop="dateTime"/>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="注册数" name="register">
        <el-card>
          <el-date-picker v-model="dateVal2" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" class="date-search"/>
          <el-button type="primary" icon="el-icon-search" @click="queryRegisterData()" circle size="mini"/>
          <el-table v-if="tableAble" :data="userRegisterCount">
            <el-table-column label="数量" prop="userCount"/>
            <el-table-column label="时间" prop="dateTime"/>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="KYC用户数" name="kyc">
        <el-card>
          <el-date-picker v-model="dataVal3" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" class="date-search"/>
          <el-button type="primary" icon="el-icon-search" @click="queryKycUserNum()" circle size="mini"/>
          <el-table :data="kycUserCount">
            <el-table-column label="数量" prop="userCount"/>
            <el-table-column label="时间" prop="dateTime"/>
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterUser",
  data() {
    return {
      type: "login",
      dateVal1: "",
      dateVal2: "",
      dataVal3:'',
    };
  },
  methods: {
    ...mapActions("dataCenter", ["getUserLoginCount", "getUserRegisterCount","getKycUserCount"]),
    queryLoginData() {
      let q = {};
      if (this.dateVal1) {
        q.startTime = this.dateVal1[0].getTime();
        q.endTime = this.dateVal1[1].getTime();
      }
      this.getUserLoginCount(q);
    },
    queryRegisterData() {
      let q = {};
      if (this.dateVal2) {
        q.startTime = this.dateVal2[0].getTime();
        q.endTime = this.dateVal2[1].getTime();
      }
      this.getUserRegisterCount(q);
    },
    queryKycUserNum(){
      let q = {};
      if (this.dataVal3) {
        q.startTime = this.dataVal3[0].getTime();
        q.endTime = this.dataVal3[1].getTime();
      }
      this.getKycUserCount(q);
    },
    tabChange() {
      if (this.type === "login") {
        this.queryLoginData();
      } else if (this.type === 'register'){
        this.queryRegisterData();
      }else if (this.type === 'kyc') {
        this.queryKycUserNum();
      }
    },
  },
  computed: {
    ...mapState("dataCenter", ["userLoginCount", "userRegisterCount", "tableAble","kycUserCount"]),
  },
  watch: {
    userLoginCount() {
      formatTable();
    },
    userRegisterCount() {
      formatTable();
    },
  },
  mounted() {
    this.queryLoginData();
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
